import axiosIns from 'utils/axios'
let epmcore ='EPM-CORE-SERVICE'

// function formatTree(e){
//   let tree = []
//   e.forEach((item)=>{
//     if(!item.mpttVOList){
//       tree.push({
//         label:item.data.name,
//         key:item.id,
//         rootId:item.rootId,
//         demandModuleId:item.data.demandModuleId || '',
//         children:[]
//       })
//     } else {
//       tree.push({
//         label:item.data.name,
//         key:item.id,
//         rootId:item.rootId,
//         demandModuleId:item.data.demandModuleId || '',
//         children:formatTree(item.mpttVOList)
//       })
//     }
//   })
//   return tree
// }

function formatTree (e) {
  let tree = []
  e.forEach((item) => {
    if (item.mpttVOList && !item.data.demandVOList){
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        demandModuleId: item.demandModuleId || '',
        children: formatTree(item.mpttVOList),
        disabled:checkDisabled(!item.demandModuleId)
      })
    } else if (item.mpttVOList && item.data.demandVOList){
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        demandModuleId: item.demandModuleId || '',
        children: formatTree(item.mpttVOList).concat(formatDemandTree(item.data.demandVOList)),
        disabled:checkDisabled(!item.demandModuleId)
      })
    } else if (!item.mpttVOList && !item.data.demandVOList){
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        demandModuleId: item.demandModuleId || '',
        children: [],
        disabled:checkDisabled(!item.demandModuleId)
      })
    } else if (!item.mpttVOList && item.data.demandVOList) {
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        demandModuleId: item.demandModuleId || '',
        children: formatDemandTree(item.data.demandVOList),
        disabled:checkDisabled(!item.demandModuleId)
      })
    } 
  })
  return tree
}
function formatDemandTree(e){
  let list = []
  e.forEach((item) => {
    list.push(Object.assign(item,{
      label: item.name,
      key: item.id,
      rootId: item.rootId,
      demandModuleId: item.demandModuleId || '',
      children: [],
      disabled:checkDisabled(!item.demandModuleId)
    }))
  })
  return list
}

function checkDisabled (e) {
  // if (e) return true
  // else return false
  return false
}

// 获取需求列表
export function getDemandList (id) {
  return axiosIns({
    url: `/api/pc/demand/list/${id}`,
    owner: epmcore,
    method: 'get'
  }).then(res=>{
    return Promise.resolve(formatTree(res.data))
  }).catch(err => {
    return Promise.reject(err)
  })
}





// WEBPACK FOOTER //
// ./src/components/demandTree/api.js